/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import type { ReactNode } from 'react';

import { pxToRem } from '@/Client/Styles/pxToRem';
import { SparkleIcon } from './ModalLib';
import { MODAL_COLORS } from './ModalStyleLib';

const CALLOUT_STYLE = css`
  label: CALLOUT_STYLE;
  margin-top: 19px;
  border-radius: 5px;
  background: ${MODAL_COLORS.infoBlueBackground};
  padding: 17px 18px 14px;
`;

const HEADER_STYLE = css`
  label: HEADER_STYLE;
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${MODAL_COLORS.infoBlue};
`;

const TITLE_STYLE = css`
  label: TITLE_STYLE;
  font-family: CircularXX, sans-serif;
  font-size: ${pxToRem(14)};
  font-style: normal;
  font-weight: 700;
  line-height: 1.429;
  letter-spacing: 0.28px;
`;

const LIST_STYLE = css`
  label: LIST_STYLE;
  margin: 8px 0 0;
  padding-left: 21px;
  color: ${MODAL_COLORS.infoBlue};

  li {
    margin: 0;
    padding-left: 6px;
    font-family: CircularXX, sans-serif;
    font-size: ${pxToRem(14)};
    font-style: normal;
    font-weight: 400;
    line-height: 1.786;
    letter-spacing: 0.28px;
  }
`;

type ModalInsightCalloutProps = {
  title: string;
  items: readonly ReactNode[];
};

export const ModalInsightCallout = ({
  title,
  items,
}: ModalInsightCalloutProps) => (
  <div css={CALLOUT_STYLE}>
    <div css={HEADER_STYLE}>
      <SparkleIcon />
      <div css={TITLE_STYLE}>{title}</div>
    </div>

    <ul css={LIST_STYLE}>
      {items.map((item, index) => <li key={index}>{item}</li>)}
    </ul>
  </div>
);
